// src/App.js
import React from 'react';
import { AuthProvider } from './hooks/useAuth';
import AppRouter from './components/AppRouter';
import './index.css'; 
import AuditResultsInterface from './components/audit/AuditResultsInterface';

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <AppRouter />
      </div>
    </AuthProvider>
  );
}

export default App;